import { GRID_SIZE } from "../constants/editor";
import type { PixelColor, PixelGrid } from "../shared/game";

export function cloneGrid(grid: PixelGrid): PixelGrid {
  return grid.map((row) => [...row]);
}

export function floodFill(
  grid: PixelGrid,
  row: number,
  col: number,
  target: PixelColor,
  fill: PixelColor,
): PixelGrid {
  if (target === fill) {
    return grid;
  }

  const nextGrid = cloneGrid(grid);
  const stack: Array<[number, number]> = [[row, col]];

  while (stack.length > 0) {
    const [r, c] = stack.pop()!;
    if (r < 0 || r >= GRID_SIZE || c < 0 || c >= GRID_SIZE) {
      continue;
    }

    if (nextGrid[r][c] !== target) {
      continue;
    }

    nextGrid[r][c] = fill;
    stack.push([r + 1, c], [r - 1, c], [r, c + 1], [r, c - 1]);
  }

  return nextGrid;
}

export function setPixel(grid: PixelGrid, row: number, col: number, value: PixelColor): PixelGrid {
  const nextGrid = cloneGrid(grid);
  nextGrid[row][col] = value;
  return nextGrid;
}

export function paintSquare(grid: PixelGrid, row: number, col: number, size: number, value: PixelColor): PixelGrid {
  const nextGrid = cloneGrid(grid);
  const half = Math.floor(size / 2);
  const startRow = row - half;
  const startCol = col - half;

  for (let r = startRow; r < startRow + size; r += 1) {
    for (let c = startCol; c < startCol + size; c += 1) {
      if (r < 0 || r >= GRID_SIZE || c < 0 || c >= GRID_SIZE) {
        continue;
      }
      nextGrid[r][c] = value;
    }
  }

  return nextGrid;
}
